export default __webpack_public_path__ + "static/media/Close.b7da4994.svg";